import default_store from '../../default_store'

const dashboardReducer = (state = default_store.pages.dashboard, action) => {
    switch (action.type) {
    default:
        return state
    }
}

export default dashboardReducer